import React, { useState } from "react";
import { Stack, Avatar, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { connect } from "react-redux";
import {
  setCli,
  setCurrentTab,
} from "../../Redux/Actions/actions.js";
import { AvcUrl, BaseUrl, PortalUrl } from "../../Container/BaseUrl/BaseUrl.js";
import axios from "axios";
import { IoMdDoneAll } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import { TbUserCog } from "react-icons/tb";
import { Grid, Box } from "@mui/material";
import { RiServerFill } from "react-icons/ri";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    voicePlatForm: state.voice.voicePlatForm,
    showIncommingscreen: state.voice.showIncommingscreen,
    skillset: state.voice.skillset,
    dailedNumberInc: state.voice.dailedNumberInc,
    cli: state.voice.cli,
    contactId: state.voice.contactId,
    CurrentTab: contactListData.CurrentTab,
    externalChatData: contactListData.externalChatData,
  };
};
const NewIncominCall = (props) => {
  const [spinner, setSpinner] = useState(false);

  const answerIncCall = async (e) => {
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let AvcUrl = localStorage.getItem("AvcUrl");
      setSpinner(true);
      await axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/answer/${localStorage.getItem("contactId")}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if ((res.data.status = "OK")) {
            setSpinner(false);
          } else {
            setSpinner(false);
          }
        })
        .catch((err) => {
          setSpinner(false);
        });
    } else if (props.voicePlatForm == "ACR") {
      localStorage.setItem("CallMadeFromDcc", "false");
      props.cli.answerCall(props.contactId);
    } else if (props.voicePlatForm == "AES") {
      const RegDetails = {
        Event: "Answer",
        Extension: JSON.parse(localStorage.getItem("CallerId")),
      };
      props.aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const rejectIncCall = async () => {
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let AvcUrl = localStorage.getItem("AvcUrl");
      await axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/disconnect/${localStorage.getItem("contactId")}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {})
        .catch((err) => {});
    } else if (props.voicePlatForm == "ACR") {
      props.cli.rejectCall(props.contactId);
      props.dropCall();
    }
  };

  const handleOpenCrmUrl = async () => {
    let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
    let AvcUrl = localStorage.getItem("AvcUrl");
    setSpinner(true);
    await axios
      .post(
        `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/answer/${localStorage.getItem("contactId")}`,
        {},
        {
          headers: {
            ssoToken: localStorage.getItem("ssoToken"),
          },
        }
      )
      .then(async (res) => {
        if ((res.data.status = "OK")) {
          setSpinner(false);
          props.setCurrentTab("Crm");
          // await CrmScreenpopupApi();
        } else {
          setSpinner(false);
        }
      })
      .catch((err) => {
        setSpinner(false);
      });
  };

  const CrmScreenpopupApi = async () => {
    let body;

    const externalChatData = props.externalChatData;

    if (externalChatData && externalChatData.channel == "voice" && (localStorage.getItem("type") === "sales" ||localStorage.getItem("type") === "service")) {
      body = {
        phonenumber: externalChatData.phonenumber,
        skillset: externalChatData.skillset,
        channel: externalChatData.channel,
        type: localStorage.getItem("type"),
        reg_no: localStorage.getItem("Contactreg_no"),
        contact_id: localStorage.getItem("ContactVoiceId"),
      };
    } else {
      body = {
        phonenumber: externalChatData?.phonenumber || props.dailedNumberInc,
        skillset:
          externalChatData?.skillset || localStorage.getItem("SkillSet"),
        channel: externalChatData?.channel || "voice",
        direction: "INBOUND",
        contactid:
          externalChatData?.voice_contactId ||
          localStorage.getItem("contactId"),
      };
    }

    try {
      const res = await axios.post(
        `${PortalUrl}/v1/purple/screenpopup`,
        body,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: localStorage.getItem("TenantId"),
          },
        }
      );

      if (res.data && res.data.data) {
        window.open(res.data.data, "_blank");
      } else {
        console.warn("No URL returned from CRM API", res.data);
      }
    } catch (err) {
      console.error("CRM screenpop API error:", err);
    }
  };

  return (
    <motion.div
      drag
      dragConstraints={props.referance}
      className="incoming-call-screen"
    >
      <Grid container>
        {/* chat details start here */}
        <Grid container alignItems={"center"} gutterBottom>
          <Grid item md={3} sx={{ position: "relative" }}>
            {/* Avatar */}
            <Avatar
              className="avatar_img"
              sx={{
                width: "3rem",
                height: "3rem",
                background: "#5647b4",
                zIndex: "999",
              }}
            />
            {/* loder animation  */}
            <div className="spinneravatar"></div>
          </Grid>
          <Grid item md={9}>
            <Stack
              direction={"row"}
              justifyContent={"start"}
              alignItems={"flex-end"}
              className="loadingtext"
            >
              <Typography variant="caption" display="block">
                Incoming Call <small></small>
              </Typography>
            </Stack>
            <Box>
              <Typography variant="h3" className="fs-17 fw-bolder" noWrap>
                {props.dailedNumberInc ? props.dailedNumberInc : ""}
              </Typography>
            </Box>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"flex-start"}
              flexWrap={"wrap"}
            >
              {/* skillset  */}
              <Typography
                variant="caption"
                display="block"
                sx={{ color: "#d9d9d9" }}
                className="me-2"
              >
                <TbUserCog className="me-1" />
                {localStorage.getItem("SkillSet")}
              </Typography>
              {/* language? */}
              {/* <Typography variant="caption" display="block" sx={{ color: "#d9d9d9" }} className="me-2">
                <IoLanguage className="me-1" />
                language
              </Typography> */}
            </Stack>
          </Grid>
        </Grid>
        {/* chat details end here */}
        {/* call controller start here */}
        <Grid container className="mt-2">
          <Grid md={12} item>
            <Box className="btn-group w-100" role="group">
              {/* btn accept  */}
              <button
                type="button"
                className="btn call-btn bg-success fs-12"
                onClick={() => answerIncCall()}
              >
                <IoMdDoneAll className="me-2" />
                Accept
              </button>
              {/* btn reject  */}
              <button
                type="button"
                className="btn call-btn bg-danger fs-12"
                onClick={() => rejectIncCall()}
              >
                <IoMdClose className="me-2" />
                Reject
              </button>
              {/* cms Screen  */}
              {(() => {
                const permissionData = localStorage.getItem("permission");
                if (!permissionData) {
                  return null; // Handle the case where "permission" is not set in localStorage
                }
                try {
                  const permissions = JSON.parse(permissionData);
                  return permissions.map((module, index) => {
                    if (module.moduleName === "INTERACTION") {
                      const crmScreen = module.screen.find(
                        (item) =>
                          item.screenId === "ANSWER_CRM_VOICE" &&
                          item.read &&
                          item.write
                      );
                      if (crmScreen) {
                        return (
                          <button
                            key={index}
                            type="button"
                            className="btn call-btn bg-secondary fs-12"
                            id="crm-button"
                            onClick={handleOpenCrmUrl}
                          >
                            <RiServerFill className="me-2" /> CRM
                          </button>
                        );
                      } else {
                        return <React.Fragment key={index}></React.Fragment>;
                      }
                    }
                    return <React.Fragment key={index}></React.Fragment>;
                  });
                } catch (error) {
                  return <></>;
                }
              })()}
            </Box>
          </Grid>
        </Grid>
        {/* call controller end here */}
      </Grid>
    </motion.div>
  );
};

export default connect(mapStateToProps, {
  setCli,
  setCurrentTab,
})(NewIncominCall);
